function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import Draft, { EditorState, RichUtils } from 'draft-js';
import { Button } from '@finect/tabular-core/Button';
import { Flex } from '@finect/tabular-core/Flex';
import { Text } from '@finect/tabular-icons/text';
import { Link } from '@finect/tabular-icons/link';
import { keyMap } from '@finect/front-utils/keyMap';
import { isURL } from '../urlCheck';
import { LinkBlockButton, EnterURL, InputField, Input, Cancel } from './linkControlComponents';
export var LinkControl = function (_React$Component) {
  _inherits(LinkControl, _React$Component);
  var _super = _createSuper(LinkControl);
  function LinkControl() {
    var _this;
    _classCallCheck(this, LinkControl);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "textInput", void 0);
    _defineProperty(_assertThisInitialized(_this), "urlInput", void 0);
    _defineProperty(_assertThisInitialized(_this), "linkBlock", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      errorURL: false
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var editorState = _this.props.editorState;
      var selection = editorState.getSelection();
      var isVisible = !selection.isCollapsed();
      if (isVisible) {
        _this.urlInput.focus();
      } else {
        _this.textInput && _this.textInput.focus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "focusEditor", function () {
      setTimeout(function () {
        return _this.props.focusEditor();
      }, 0);
    });
    _defineProperty(_assertThisInitialized(_this), "confirmLink", function (event) {
      event.preventDefault();
      var textValue = _this.textInput ? _this.textInput.value : '';
      var url = _this.urlInput.value;
      if (url === '') {
        _this.props.hideLink();
        return;
      }
      if (!url.includes('http')) {
        url = "https://".concat(url);
      }
      if (!isURL(url)) {
        return _this.setState({
          errorURL: true
        });
      }
      var _this$props = _this.props,
        editorState = _this$props.editorState,
        onChange = _this$props.onChange;
      var contentState = editorState.getCurrentContent();
      var contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', {
        url: url
      });
      var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      var selection = editorState.getSelection();
      var isVisible = !selection.isCollapsed();
      if (isVisible) {
        var newEditorState = EditorState.set(editorState, {
          currentContent: contentStateWithEntity
        });
        onChange(RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey));
      } else {
        if (textValue === '') return;
        var newContent = Draft.Modifier.insertText(contentState, selection, "".concat(textValue, " "), null, entityKey);
        var _newEditorState = EditorState.set(editorState, {
          currentContent: newContent
        });
        onChange(_newEditorState);
      }
      _this.setState({
        errorURL: false
      }, _this.focusEditor);
      _this.props.hideLink();
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      if (event.which === keyMap.RETURN) {
        _this.confirmLink(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      if (_this.state.errorURL) _this.setState({
        errorURL: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var urlValue = _this.urlInput.value;
      if (urlValue === '') return;
      var url = !urlValue.includes('http') ? "https://".concat(urlValue) : urlValue;
      if (!isURL(url)) {
        _this.setState({
          errorURL: true
        });
      }
    });
    return _this;
  }
  _createClass(LinkControl, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var errorURL = this.state.errorURL;
      var _this$props2 = this.props,
        editorState = _this$props2.editorState,
        hideLink = _this$props2.hideLink;
      var selection = editorState.getSelection();
      var isVisible = !selection.isCollapsed();
      var hasTouch = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
      var confirmProps = hasTouch ? {
        onTouchStart: this.confirmLink
      } : {
        onMouseDown: this.confirmLink
      };
      var cancelProps = hasTouch ? {
        onTouchStart: hideLink
      } : {
        onMouseDown: hideLink
      };
      return React.createElement(LinkBlockButton, {
        ref: function ref(el) {
          return _this2.linkBlock = el;
        }
      }, React.createElement(EnterURL, null, !isVisible ? React.createElement(InputField, {
        iconLeftPosition: "3px"
      }, React.createElement(Input, {
        id: "text",
        ref: function ref(el) {
          return _this2.textInput = el;
        },
        type: "text",
        placeholder: "Texto a mostrar"
      }), React.createElement(Text, {
        size: "16",
        strokeWidth: "1.6"
      })) : null, React.createElement(InputField, null, React.createElement(Input, {
        id: "link",
        ref: function ref(el) {
          return _this2.urlInput = el;
        },
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        type: "text",
        error: errorURL,
        placeholder: "Direcci\xF3n de enlace"
      }), React.createElement(Link, {
        size: "18",
        strokeWidth: "1.5"
      })), React.createElement(Flex, {
        align: "center",
        justify: "flex-end"
      }, React.createElement(Cancel, cancelProps, "Cancelar"), React.createElement(Button, _extends({
        width: "auto",
        variant: "small"
      }, confirmProps), "A\xF1adir"))));
    }
  }]);
  return LinkControl;
}(React.Component);